import { LoadingStatusUpdateInfo } from '../alerts/typings/models';

import { AppRootScope } from '../../src/typings/AppRootScope';
import { EventTypes } from '../../src/typings/models';

import { SubscriptionTypes } from '../alerts/typings/SubscriptionTypes';
import { AppContextService } from '../appContext/AppContextService';
import { NotificationService } from '../notification/NotificationService';

import { Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UserInformationService } from '../userInformation/UserInformationService';
import { IconSize, IconSizeEnum } from './LoadingAnimation';

/**
 * Component that renders pulsing CASLink icon
 */

@Component({
    encapsulation: ViewEncapsulation.None, // so mat-icon styles apply
    selector: 'loading-animation',
    styleUrls: ['./LoadingAnimation.scss'],
    templateUrl: './LoadingAnimationView.html'
})
export class LoadingAnimationComponent implements OnDestroy, OnInit {
    public static $name: string = 'loadingAnimation';

    constructor(
        @Inject('$rootScope') private $rootScope: AppRootScope,
        private appContextService: AppContextService,
        private notificationService: NotificationService,
        private userInfoService: UserInformationService
    ) {
    }

    @Input() public message: string;

    /**
     * A requestContext must be generated in the parent controller and passed into this component in order for live status updating to work.
     * This context will be passed to the server & will ensure that only the
     * components matching the request context are updated when an update was sent.
     */
    @Input() public requestContext: string;

    @Input() public size: IconSize;
    iconSizeEnum = IconSizeEnum;

    public canDisplayMessage: boolean;

    /**
     * The number of milliseconds that must have passed since initialization to begin displaying server messages
     */
    private messageDelay: number = 100;

    /**
     * The username is used to filter updates on the backend to only go back to the user that initiated the request
     */
    private username: string;

    public ngOnDestroy() {
        const locationId = this.appContextService.loadedLocationId;

        if (this.requestContext) {
            this.notificationService.stopUpdates(locationId, SubscriptionTypes.UserSpecificLoadingStatus, {
                requestContext: this.requestContext,
                username: this.username
            });
        }
    }

    public ngOnInit() {
        this.setupSubscriptions();
    }

    private setupSubscriptions() {
        const locationId = this.appContextService.loadedLocationId;

        if (this.requestContext) {
            this.username = this.userInfoService.getUserName();

            this.notificationService.startUpdates(locationId, SubscriptionTypes.UserSpecificLoadingStatus, {
                requestContext: this.requestContext,
                username: this.username
            }, null);

        }

        this.$rootScope.subscribe(EventTypes.LoadingStatusUpdate, (data: LoadingStatusUpdateInfo) => {
            if (this.requestContext === data.requestContext) {
                this.message = data.message;
            }
        });

        setTimeout(() => {
            this.canDisplayMessage = true;
        }, this.messageDelay);
    }
}
